import React from 'react';
import { Phone, Mail, MessageCircle, Instagram } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Contact = () => {
  const contactMethods = [
    {
      icon: Phone,
      label: 'Telefon',
      value: contactInfo.phone,
      href: `tel:${contactInfo.phone.replace(/\s/g, '')}`,
    },
    {
      icon: Mail,
      label: 'Email',
      value: contactInfo.email,
      href: `mailto:${contactInfo.email}`,
    },
    {
      icon: MessageCircle,
      label: 'WhatsApp / Viber',
      value: 'Pošaljite poruku',
      href: `https://wa.me/${contactInfo.whatsapp}`,
    },
    {
      icon: Instagram,
      label: 'Instagram',
      value: '@peakview508_apartman',
      href: contactInfo.instagram,
    },
  ];

  return (
    <section id="kontakt" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-sage-400 text-sm font-medium tracking-wider mb-2">Kontakt</p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-white">
            Javite nam se
          </h2>
        </div>

        {/* Contact Cards */}
        <div className="grid md:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {contactMethods.map((method, index) => (
            <a
              key={index}
              href={method.href}
              target={method.label === 'WhatsApp / Viber' || method.label === 'Instagram' ? '_blank' : undefined}
              rel={method.label === 'WhatsApp / Viber' || method.label === 'Instagram' ? 'noopener noreferrer' : undefined}
              className="bg-gray-800 hover:bg-gray-700 rounded-2xl p-6 text-center transition-all duration-300 group hover:scale-105"
            >
              <div className="bg-sage-600 w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-sage-500 transition-colors duration-300">
                <method.icon size={24} className="text-white" />
              </div>
              <h3 className="text-white font-bold mb-2">{method.label}</h3>
              <p className="text-gray-400 text-sm">{method.value}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;